import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FindSuppliers } from '../../../shared/components/global/FindSuppliers';

interface IFindSuppliersModalProps {
    show: boolean;
    closeModal: () => void;
}

export function FindSuppliersModal({ show, closeModal }: IFindSuppliersModalProps) {
    const { t } = useTranslation();
    const isMobile = window.innerWidth <= 700;
    const navigate = useNavigate();
    const goToMyCampaigns = () => {
        navigate('/brand/campaign');
        closeModal();
    };
    return (
        <Modal
            show={show}
            onHide={closeModal}
            className="modal-dark"
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered={true}
        >
            <Modal.Body>
                {!isMobile && (
                    <Button
                        onClick={goToMyCampaigns}
                        className="d-md-none w-100 mb-3"
                        variant="outline-primary"
                        size="sm"
                    >
                        {t('agency.see_all_camp')}
                    </Button>
                )}

                <FindSuppliers closeModal={closeModal} idScroll="supplierSearchModal" />
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-end">
                <Button onClick={closeModal} variant="outline-primary" className="btn-sm mx-2">
                    {t('general.button.cancel')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
